import { FlowV2_Action__Input } from '~/graphql/types';
import { ClientFlowActionRealworksSendContact } from '~/graphql/types.client';

/**
 *
 * @param {ClientFlowActionRealworksSendContact} action - RealworksSendContact client action
 * keywords:
 */
const serializeRealworksSendContactAction = (
  action: ClientFlowActionRealworksSendContact,
): FlowV2_Action__Input => {
  const {
    id,
    accountId,
    flowBlueprintId,
    parentIds,
    tokenContainerId,
    sendToContactOwner,
  } = action;

  return {
    Realworks: {
      SendContact: {
        id,
        accountId,
        flowBlueprintId,
        parentIds,
        tokenContainerId,
        sendToContactOwner,
      },
    },
  };
};
export default serializeRealworksSendContactAction;
